import {Collection, Model} from '@vuex-orm/core';
import UnitPlan from '../../units/UnitPlan';
import Oa from './Oa';
import {orderBy} from 'lodash';
import UnitPlanComments from '../../units/UnitPlanComments';

export default class UnitPlanOa extends Model {
    static entity = 'unitplan_oas';

    static fields () {
        return {
            id: this.number(0),
            oa_id: this.number(null),
            unitplan_id: this.number(null),
            complement: this.boolean(false), // Indica si es oa de complemento
            hours: this.string('00:00'),
            eje_id: this.number(0),
            rescheduled: this.boolean(false).nullable(),
            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            // compatibilidad
            selectedRows: this.attr([]), // OAS

            // Para orden en data tables
            oa_cod: this.string('').nullable(),

            //
            unitplan: this.belongsTo(UnitPlan, 'unitplan_id'),
            oa: this.hasOne(Oa, 'id', 'oa_id'),
            comments: this.hasMany(UnitPlanComments, 'idPlanUnidadOA'),
        };
    }

    public static getAllByPlanUnidad(idPlanUnidad: number, filterDisabled?: boolean): Collection<UnitPlanOa> {
      const oas = this.query()
        .where('unitplan_id', idPlanUnidad)
        .where((puOA: any) => filterDisabled && !puOA.disabled && !puOA.rescheduled)
        .with('oa', (queryOas) => {
          queryOas.with('ies', (queryIes) => {
            queryIes.where((ie) => filterDisabled && !ie.disabled && !ie.rescheduled).orderBy('cod');
          });
        }).
        get();
      if (!Array.isArray(oas)) { return []; }
      return orderBy(oas, ['oa.cod']);
    }
}
